import React, {Component} from 'react';
import MainMapComponent from './MainMapComponent'
import config from './config'

const ELECTIONS = [
  {
    'key': 'parliament',
    'name': 'नेपाल',
    'province': null
  },
  {
    'key': 'pradesh1',
    'name': 'प्रदेश नं १',
    'province': 8
  },
  {
    'key': 'pradesh2',
    'name': 'प्रदेश नं २',
    'province': 5
  },
  {
    'key': 'pradesh3',
    'name': 'प्रदेश नं ३',
    'province': 2
  },
  {
    'key': 'pradesh4',
    'name': 'प्रदेश नं ४',
    'province': 3
  },
  {
    'key': 'pradesh5',
    'name': 'प्रदेश नं ५',
    'province': 6
  },
  {
    'key': 'pradesh6',
    'name': 'प्रदेश नं ६',
    'province': 4
  },
  {
    'key': 'pradesh7',
    'name': 'प्रदेश नं ७',
    'province': 7
  }
];

const tabStyles = {
  textDecoration: 'none',
  padding: '4px 12px',
  backgroundColor: 'white',
  fontSize: 14,
  border: 0,
  borderBottom: '3px solid transparent',
  borderRadius: 0,
  outline: "none",
  cursor: 'pointer',
  marginBottom: 4
}

class Container extends Component {
  state = {
    election: "parliament"
  }
  handleElectionChange = (election) => {
    this.setState({election})
  }

  handleRegionClick = (region) => {
    window.open(`${config.base_url}/#/${this.state.election}/${region.id}`, '_blank');
  }

  render() {
    return (
      <div>
        <div style={{textAlign: 'left'}}>
          {
            ELECTIONS.map((e) => {
              let styles = {...tabStyles};

              if(this.state.election == e.key) {
                styles['borderBottom'] = '3px solid #3F51B5'
              }

              return (
                (
                  <button 
                    style={styles}
                    type="button"
                    key={e.key}
                    onClick={this.handleElectionChange.bind(this, e.key)}
                  >
                    <span>{e.name}</span>
                  </button>    
                )
              )
            })
          }
        </div>
        <MainMapComponent 
          election={this.state.election} 
          height={this.props.height} 
          width={this.props.width}
          onRegionClick={this.handleRegionClick}
        />
      </div>
    )
  }
}

export default Container;


// WEBPACK FOOTER //
// ./src/Container.js